import React, { useEffect, useImperativeHandle, useState } from 'react';
import * as S from './Snackbar.styles';
import { SNACKBAR_HIDE_TIME } from '@/components/UI/SnackBar/Snackbar.constants';

export interface SnackbarRef {
  open: (message: string) => void;
}

export const Snackbar = React.forwardRef<SnackbarRef>((_, snackbarRef) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  useImperativeHandle(
    snackbarRef,
    () => ({
      open: m => {
        setIsOpen(true);
        setMessage(m);
      },
    }),
    []
  );

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setIsOpen(false);
      }, SNACKBAR_HIDE_TIME);
    }
  }, [isOpen]);

  return <S.Box $isOpen={isOpen}>{message}</S.Box>;
});

Snackbar.displayName = 'Snackbar';
